import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import {
    ArrowUpAZ,
    ArrowDownZA,
    ArrowUpDown,
    Settings,
    Lock,
    ArrowLeftToLine,
    ArrowRightToLine,
    Zap,
    EyeOff,
    Copy,
    Trash2,
    Sparkles,
    X
} from 'lucide-react';

const ColumnOptionsPopover = ({ onClose, onAction, position, column }) => {
    const popoverRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popoverRef.current && !popoverRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    if (!position) return null;

    const style = {
        top: position.top + 5,
        left: position.left,
        zIndex: 100,
    };

    // Adjust if going off screen
    if (window.innerWidth - position.left < 250) {
        style.left = 'auto';
        style.right = 20;
    }

    const MenuItem = ({ icon: Icon, label, action, danger = false, separator = false, highlight = false }) => (
        <>
            <button
                onClick={() => {
                    onAction(action, column);
                    onClose();
                }}
                className={`w-full text-left px-3 py-2 flex items-center gap-3 transition-colors
          ${danger ? 'text-red-600 hover:bg-red-50' : 'text-gray-700 hover:bg-gray-100'}
          ${highlight ? 'bg-purple-50 text-purple-700 hover:bg-purple-100 border border-purple-100 rounded-md my-1 mx-2 w-auto' : ''}
        `}
            >
                <Icon size={16} className={highlight ? 'text-purple-600' : danger ? 'text-red-500' : 'text-gray-500'} />
                <span className={`text-sm ${highlight ? 'font-medium' : ''}`}>{label}</span>
            </button>
            {separator && <div className="h-px bg-gray-100 my-1" />}
        </>
    );

    return createPortal(
        <div
            ref={popoverRef}
            style={style}
            className="fixed w-64 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden flex flex-col animate-in fade-in zoom-in-95 duration-100"
        >
            <div className="py-1">
                <MenuItem icon={ArrowUpAZ} label="Ordenar ascendente" action="sort_asc" />
                <MenuItem icon={ArrowDownZA} label="Ordenar descendente" action="sort_desc" separator />

                <MenuItem icon={Settings} label="Modifica el campo" action="modify" />
                <MenuItem icon={Lock} label="Privacidad y permisos" action="privacy" separator />

                <MenuItem icon={ArrowLeftToLine} label="Mover al inicio" action="move_start" />
                <MenuItem icon={ArrowRightToLine} label="Mover al final" action="move_end" />
                <MenuItem icon={Zap} label="Automatizar" action="automate" separator />

                <MenuItem icon={EyeOff} label="Ocultar columna" action="hide" />
                <MenuItem icon={Copy} label="Duplicar" action="duplicate" />
                <MenuItem icon={Trash2} label="Eliminar campo" action="delete" danger separator />

                <MenuItem icon={Sparkles} label="Configurar relleno con IA" action="ai_fill" highlight />
            </div>
        </div>,
        document.body
    );
};

export default ColumnOptionsPopover;
